import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useReportIssue from '../../../../hooks/dashboard/driver-list/useReportIssue';
import {
  ReportIssueDataType,
  ReportIssueInitialValues,
  ReportIssueSchema,
} from '../../../../models/dashboard/driver-list/report-issue';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import CustomSelectField from '../../../FormCom/CustomSelectField';
import { FormComponent } from '../../../FormCom/FormComponent';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface ReportIssueModalProps {
  data: any;
}

const ReportIssueModal: React.FC<ReportIssueModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const { reportIssue, loading } = useReportIssue();

  const onSubmit = (values: ReportIssueDataType) => {
    reportIssue(values, data?.id);
    modalContext?.setShowModal(false);
  };

  return (
    <ModalContainer label='Report Issue'>
      <FormComponent
        initialValues={ReportIssueInitialValues}
        schema={ReportIssueSchema}
        onSubmit={onSubmit}
      >
        <CustomSelectField
          name='issueType'
          id='issueType'
          label='Issue Type'
          placeholder='Select...'
          optionData={[
            'Not aware of other active employment',
            'Outstanding company property.',
          ]}
        />
        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton loading={loading} className='fill'>
            Report
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

const ButtonArea = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
`;

export default ReportIssueModal;
